































import { computed, defineComponent, nextTick, onMounted, PropType, ref, toRef, watch } from "@vue/composition-api";
import { isMobile } from "@/lib/browserUtils";
import { INPUT_PROPS } from "@/const";
import BaseInput from "@/components/BaseInput";

export default defineComponent({
  name: "BaseInputTextarea",
  components: { BaseInput },
  props: {
    ...INPUT_PROPS,
    rowHeight: { type: Number, default: 56 },
    rows: { type: Number, default: 2 },
    maxRows: { type: Number, default: 5 },
    autoGrow: { type: Boolean, default: false },
    disabled: { default: false },
    fieldClass: { type: [String, Object, Array] },
    submit: {
      type: String as PropType<"" | "enter" | "shiftEnter">,
      default: "",
      validator: (value: string) => ["", "enter", "shiftEnter"].includes(value),
    },
  },
  setup(props, { emit }) {
    const textareaElement = ref<HTMLInputElement>();
    const contentHeight = ref(0);

    const minHeight = computed(() => props.rows * (props.rowHeight - 25) + 25);
    const maxHeight = computed(() => props.maxRows * (props.rowHeight - 25) + 25);
    const currentHeight = computed(() => {
      const defaultHeight = props.rows * (props.rowHeight - 25) + 25;
      if (!props.autoGrow) return defaultHeight;
      return Math.min(contentHeight.value, maxHeight.value);
    });

    const onKeyDown = (e: KeyboardEvent) => {
      if (
        e.key !== "Enter" ||
        !props.submit ||
        (props.submit === "shiftEnter" && !e.shiftKey) ||
        (props.submit === "enter" && e.shiftKey) ||
        isMobile()
      ) {
        return;
      }
      e.preventDefault();
      emit("submit");
    };

    const onKeyUp = () => {
      emit("keyup", props.value);
    };

    watch(
      toRef(props, "value"),
      async value => {
        let el: HTMLInputElement | undefined;
        await nextTick();
        try {
          el = textareaElement.value;
        } catch (e) {}
        if (!el) return;
        let initialValue = el.value;

        el.value = value ?? "";
        el.style.height = "";
        contentHeight.value = el.scrollHeight;
        el.value = initialValue;
        el.style.height = currentHeight.value + "px";
        emit("resize", currentHeight.value);
      },
      { immediate: true }
    );

    onMounted(() => {
      emit("defineFocus", () => textareaElement.value?.focus());
    });

    return {
      textareaElement,
      minHeight,
      maxHeight,
      onKeyDown,
      onKeyUp,
    };
  },
});
